import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import { ROUTER } from '../../../class/constants'

import { Alert, Label, Loader } from '../../default'
import { acGetCustomersByCnpj } from '../../../class/actions'

function PanelSearchCnpj({
  classes,
  cnpj,
  cnpjCustomers,
  isLoadingCnpjCustomers,
  TableComponent
}) {
  const { t } = useTranslation(), dispatch = useDispatch(), history = useHistory()

  const historyRef = useRef(null)

  const [searchError, setSearchError] = useState(null)

  useEffect(() => {
    const search = () => {

      setSearchError(null)

      dispatch(acGetCustomersByCnpj(cnpj))
        .catch(() => setSearchError(t('panels.search.cnpj.unknown')))
        .finally(() => {
          if (historyRef && historyRef.current)
            historyRef.current.scrollIntoView({ behavior: 'smooth' })
        })
    }

    search()

    // DO NOT DELETE NEXT LINE
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid container spacing={2} className={classes.root}>

      {/* Title */}
      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.search.result') + `"${cnpj}"`}</Label>
      </Grid>

      {/* Error / Loading */}
      <Grid item xs={12}>
        { isLoadingCnpjCustomers && <Loader /> }
        { searchError && <Alert text={searchError} color="error" noMargin /> }
      </Grid>

      {/* History Panel */}
      <Grid ref={historyRef} item xs={12} style={{ marginTop: '16px' }}>
      {
          cnpjCustomers.length > 0 ? (
            <TableComponent customers={cnpjCustomers} />
          ) : (
            !isLoadingCnpjCustomers ? (
              <Alert style={{ cursor: 'pointer' }} text={t('panels.search.cnpj.none')} color="warning" noMargin onClick={() => history.push(ROUTER.BLOCK)} />
            ) : null
          )
        }
      </Grid>
    </Grid>
  )
}

const mapStateToProps = ({ ReducerSearch }) => ({
  cnpjCustomers: ReducerSearch.cnpjCustomers,
  isLoadingCnpjCustomers: ReducerSearch.isLoadingCnpjCustomers
})

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default connect(mapStateToProps)(withStyles(styles)(PanelSearchCnpj))